import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Layout from "../../../Layout";
import { constants } from "../../../constants/constants";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import HeaderBread from "../../../components/HeaderBread";
import DeletePop from "../../../constants/ErrorPermissionModal";
import { checkPermission } from "../../../utils/Validation/checkPermission";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import { message } from "antd";
import { deleteLoginPageData, getLoginPageData } from "../../../utils/ApiCalls/LoginPage";

const LoginPageList = () => {
    const [{ userDetails, permission }] = useDataLayerValue();

    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize] = useState(10);
    const [count, setCount] = useState(0);
    const [search, setSearch] = useState("");
    const [active, setActive] = useState("listing");

    const navigation = [
        {
            title: "Home",
            route: "/",
        },
        {
            title: "Login Page List",
            route: "/website/cms/login-page",
        },
    ];
    useEffect(() => {
        fetchData();
    }, [page, search]);

    const fetchData = async () => {
        const res = await getLoginPageData();
        if (res) {
            setRows(res);
            setCount(res);
        }
    };
    const handleEdit = async (id) => {
        if (checkPermission(permission, "update_per", "login-page", window?.location?.pathname)) {
            navigate("/website/webpages/login-page/edit/" + id);
        } else {
            message.error("Update permission missing");
        }
    };
    const handleDelete = async (id) => {
        await deleteLoginPageData(id);
        Swal.fire("Deleted!", "Login page slider image has been deleted.", "success");
        fetchData();
    }

    return (
        <Layout type={"read_per"} module_data={"login-page"}>
            <CustomHeaderTitle title={"Login Page"} />
            <div>
                <div>
                    <HeaderBread navigation={navigation} title={"Login Page"}></HeaderBread>
                </div>

                <section className="content" style={{ marginTop: "20px" }}>
                    <div
                        style={{
                            display: "flex",

                            flexDirection: "column",
                        }}
                    ></div>
                    <div className="container-fluid">
                        {" "}
                        {active === "listing" && (
                            <div className="card">
                                <div className="card-header two_item">
                                    <h5 className="card-title">Login Page Images List</h5>

                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            gap: "5px",
                                            width: "80%",
                                            justifyContent: "flex-end",
                                        }}
                                    >
                                        <Link
                                            to="/website/webpages/login-page/add"
                                            className="btn add_v_btn"
                                            style={{ width: "200px" }}
                                        >
                                            Add Image
                                        </Link>
                                    </div>
                                </div>

                                {/* Table */}
                                <div className="card-body">
                                    <table className="table table-bordered table_holder">
                                        <thead>
                                            <tr>
                                                <th style={{ width: "2%" }}>Sl</th>
                                                <th>Image</th>
                                                <th>Simplified Chinese Image
                                                </th>
                                                <th>Traditional Page Image
                                                </th>
                                                <th>Bahasa Page Image</th>
                                                <th style={{ width: "0%" }}>Action</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {rows.length === 0 && (
                                                <tr>
                                                    <td colSpan="6" className="text-center">
                                                        No Images Found
                                                    </td>
                                                </tr>
                                            )}

                                            {rows.map((item, index) => (
                                                <tr key={item.id}>
                                                    <td>{(page - 1) * pageSize + index + 1}</td>

                                                    <td>
                                                        <img
                                                            src={`${constants.MEDIAURL}/${item.image}`}
                                                            alt="banner"
                                                            style={{ width: "220px", height: "150px" }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <img
                                                            src={`${constants.MEDIAURL}/${item.simplified_chinese_image}`}
                                                            alt="banner"
                                                            style={{ width: "220px", height: "150px" }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <img
                                                            src={`${constants.MEDIAURL}/${item.traditional_chinese_image}`}
                                                            alt="banner"
                                                            style={{ width: "220px", height: "150px" }}
                                                        />
                                                    </td>
                                                    <td>
                                                        <img
                                                            src={`${constants.MEDIAURL}/${item.bahasa_image}`}
                                                            alt="banner"
                                                            style={{ width: "220px", height: "150px" }}
                                                        />
                                                    </td>

                                                    <td>
                                                        <div className="table_action_btn">
                                                            <button className="btn" onClick={() => handleEdit(item.id)}>
                                                                <i
                                                                    className="ri-edit-2-line"
                                                                    data-toggle="tooltip"
                                                                    title="Edit"
                                                                ></i>
                                                            </button>

                                                            <DeletePop
                                                                onConfirm={() =>
                                                                    handleDelete(item.id)
                                                                }
                                                            >
                                                                <div>
                                                                    {" "}
                                                                    <button className="btn delete_btn">
                                                                        <i
                                                                            className="ri-delete-bin-line"
                                                                            data-toggle="tooltip"
                                                                            title="Delete"
                                                                        ></i>
                                                                    </button>
                                                                </div>
                                                            </DeletePop>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )}{" "}

                    </div>
                </section>
            </div>

        </Layout >
    );
};

export default LoginPageList;
